import { Directive } from '@angular/core';

@Directive({
  selector: '[xpo-alternate-tabs], [xpoAlternateTabs]',
  host: { class: 'xpo-AlternateTabs' },
})
export class XpoAlternateTabs {}
